import type { FormFieldConfig } from '../components/common/FormField';

export const sponsorFieldConfig: {
  section: string;
  columns: number;
  column: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Sponsor Details',
    columns: 1,
    column: 0,
    fields: [
      { field: 'sponsor_name', label: 'Sponsor Name', type: 'text' },
      {
        field: 'sponsor_type',
        label: 'Type',
        type: 'select',
        optionsKey: 'sponsorTypes',
        isStringArray: true,
      },
      { field: 'sponsor_address', label: 'Address', type: 'text' },
      { field: 'kyc_completed', label: 'KYC Completed?', type: 'checkbox' },
      { field: 'short_description', label: 'Short Description', type: 'multiline' },
      { field: 'credit_assessment', label: 'Credit Assessment', type: 'multiline' },
      { field: 'credit_risk', label: 'Credit Risk', type: 'text' },
    ],
  },
];
